import React, { useState } from "react";
import "./CustomerOrder.scss";
import right_girl from "../../Images/right_girl.png";
import Food_Text from "../../Images/chat.png";
import { Container } from "react-bootstrap";
import EnquirePopup from "../EnquirePopup";

const CustomerOrder = () => {
  const [showPopup, setShowPopup] = useState(false);


  const handlePopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };


  const OpneLinkHandle = () =>{
    window.open("https://app.businessbay.io/register", "_blank");
  }
  return (
    <Container>
      <div className="customer_main_wrapper">
        <div className="customer_order_main_wrapper">
          <div className="customer_upper_main_wrapper">
            <div className="desire_text">From</div>
            <div className="customer_image_wrapper">
              <img src={Food_Text} />
            </div>
          </div>
          <div className="desire_text">To Plate</div>
          <div className="customer_text_wrapper">
          We’re bridging the gap between food and foodies with a tap on the screen. Whether it's a gourmet feast or a late-night snack, our app connects the right restaurants with the right customers.
          </div>
          <div className="order_now_wrapper redbutton"
          //  onClick={OpneLinkHandle}
          onClick={handlePopup}
           >Get started</div>
        </div>

        <div className="customer_lower_wrapper">
          <img src={right_girl} />
        </div>
          {showPopup && (
               <EnquirePopup   open={showPopup} onClose={closePopup} setOpen={setShowPopup}/>
              )}
      </div>
    </Container>
  );
};

export default CustomerOrder;
